const ENProjectRestrictions = {
	"Adicionar Restrição": "Add Restriction",
	"Nenhuma restrição adicionada": "No added restriction",
	"Restrição": "Restriction"
	
};

export default ENProjectRestrictions;
